import { Form, Select } from 'antd';
const { Option } = Select;


export const suffixSelector = (
  <Form.Item name="symbol" noStyle>
    <Select style={{ width: 70 }}>
      <Option value="RUB">RUB</Option>
      <Option value="USD">USD</Option>
      <Option value="EUR">EUR</Option>
      <Option value="CNY">CNY</Option>
      <Option value="">Пусто</Option>
    </Select>
  </Form.Item>
);
export const suffixSelectorCrane = (
  <Form.Item name="symbolCrane" noStyle>
    <Select style={{ width: 70 }}>
      <Option value="RUB">RUB</Option>
      <Option value="USD">USD</Option>
      <Option value="EUR">EUR</Option>
      <Option value="CNY">CNY</Option>
      <Option value="">Пусто</Option>
    </Select>
  </Form.Item>
);
export const suffixSelectorDay = (
  <Form.Item name="symbolDay" noStyle>
    <Select style={{ width: 70 }}>
      <Option value="RUB">RUB</Option>
      <Option value="USD">USD</Option>
      <Option value="EUR">EUR</Option>
      <Option value="CNY">CNY</Option>
      <Option value="">Пусто</Option>
    </Select>
  </Form.Item>
);